import CampaignEmailLink from './CampaignEmailLink';
import { authRoles } from 'app/auth';

export const CampaignEmailLinkConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false
        },
        toolbar: {
          display: false
        },
        leftSidePanel: {
          display: false
        },
        rightSidePanel: {
          display: false
        }
      }
    }
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/join/:campaignSlug',
      component: CampaignEmailLink
    }
  ]
};
